import React, { useEffect } from "react";
import "./App.css";
import { OandMComponent } from "./OandMComponent";
import { IressToasterProvider } from "@iress/ids-components";
import '@iress/ids-components/dist/style.css';

const App: React.FC = () => {
  // Set document title using useEffect to avoid running on every render
  useEffect(() => {
    document.title = "O&M Profiler";
  }, []);

  return (
    <IressToasterProvider>
      <div className="App">
        <h2 className="App-header">Pensions and Investments Analysis (O&amp;M Profiler)</h2>
        <OandMComponent />
      </div>
    </IressToasterProvider>
  );
};

export default App;
